import wellknown from 'wellknown';

// A function that returns geojson from wkt
export const wktToGeoJson = (wkt: string) => {
    return wellknown.parse(wkt);
};
